import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "address-option__text"
}
const _hoisted_2 = {
  key: 1,
  class: "address-option__text"
}
const _hoisted_3 = {
  key: 2,
  class: "address-option__text"
}

import { PropType } from "vue";
import { ICustomerAddress } from "@/models/ICustomerAddress";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressCheckoutAddressOption',
  props: {
  address: {
    type: Object as PropType<ICustomerAddress>,
    required: true,
  },
},
  emits: {
  click: (address: ICustomerAddress) => {
    return !!address;
  },
},
  setup(__props, { emit }) {

const props = __props;



const onClick = () => {
  emit("click", props.address);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["address-option", { 'address-option--selected': __props.address.selected }]),
    type: "button",
    onClick: onClick
  }, [
    (__props.address.fullName)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.address.fullName), 1))
      : _createCommentVNode("", true),
    (__props.address.address)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.address.address), 1))
      : _createCommentVNode("", true),
    (__props.address.zipcode && __props.address.city)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.address.zipcode) + " " + _toDisplayString(__props.address.city), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})